const PROFILE_ROUTES = Object.freeze({
	profile: {
		name: 'PorfileRoot',
		path: '/profile',
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/modules/profile/views/RootView.vue'),
	},
	profileShop: {
		name: 'ProfileShopId',
		path: ':shopId',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/shop-view/ShopView.vue'),
	},
	profilePost: {
		name: 'ProfilePostId',
		path: ':shopId/post/:postId',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/PostView.vue'),
	},
	profileSetting: {
		name: 'ProfileSetting',
		path: 'setting',
		component: () => import('@/presentation/modules/profile/views/SettingView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	profileCreatePost: {
		name: 'ProfileCreatePost',
		path: 'create-post',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/profile/views/CreatePostView.vue'),
	},
	profileArtist: {
		name: 'ProfileArtist',
		path: ':shopId/artists',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/profile/views/ArtistView.vue'),
	},
	profileService: {
		name: 'ProfileService',
		path: ':shopId/artists/:serviceId',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/profile/views/ServiceView.vue'),
	},
	profileChooseTime: {
		name: 'ProfileChooseTime',
		path: ':shopId/artists/:serviceId/choose-time',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/profile/views/ChooseTimeView.vue'),
	},
});

export default PROFILE_ROUTES;
